






































































































































































import CertificateRegistrationPopup from '@/components/popup/page/CertificateRegistration.vue'
import ListView from '@/components/ListView.vue'
import TransferPopups from '@/components/popup/TransferPopups.vue'
import ChangeStatusPopup from '@/components/popup/btt/ChangeStatus.vue'
import ClientFilterPopup from '@/components/popup/btt/ClientFilter.vue'
import DialogDrawer from '@/components/DialogDrawer.vue'
import OrderPopup from '@/components/popup/btt/Order.vue'
import TitleAndMessage from '@/components/TitleAndMessage.vue'
import WorkflowHandler from '@/components/WorkflowHandler.vue'
import FooterLayout from '@/components/Footer.vue'
import HeaderLayout from '@/components/Header.vue'
import FooterButton from '@/components/FooterButton.vue'
import Translation from '@/mixins/Translation'
import InvoiceCard from '@/components/card/InvoiceCard.vue'
import ClientAccountFormPopup from '@/components/popup/btt/ClientAccountForm.vue'
import ClientAccountSelectionPopup from '@/components/popup/btt/ClientAccountSelection.vue'
import ClientBankCodeSelectionPopup from '@/components/popup/btt/BankCodeSelection.vue'
import {Component, Mixins, Prop, Watch, Ref} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import {sumBy} from 'lodash'
import toCurrency from '@/filters/to-currency'
import {Row, Checkbox} from 'element-ui'
import {LocaleMessage} from 'vue-i18n'
import {Client} from '@/store/modules/clients'
import {BizPropertyPayload} from '@/store/modules/gtm/types'
import {Invoice} from '@/store/modules/invoices/types'
import {DeleteClientBankAccountPayload} from '@/store/modules/clients/types'
import PopupHandlerMixin from '@/mixins/popupHandler'

const invoices = namespace('invoices')
const layout = namespace('layout')
const clients = namespace('clients')
const institutions = namespace('institutions')
const transfer = namespace('transfer')
const banks = namespace('banks')
const biz = namespace('biz')
const gtm = namespace('gtm')

const AVAILABLE_TRANSFER_MAX_COUNT = 10

type DialogName = '' | 'inspect-bank' | 'need-bank-cert' | 'expired' | 'empty-client-bank-account'

interface DialogOptions {
  header: string | LocaleMessage
  title: string | LocaleMessage
  description: string | LocaleMessage
  status?: string | null
  showCancel: boolean
  closeFunc: (status: boolean) => void | null
  cancelText?: string
  confirmText?: string
  translation?: string
}

@Component({
  components: {
    FooterButton,
    WorkflowHandler,
    CertificateRegistrationPopup,
    ChangeStatusPopup,
    ListView,
    ClientFilterPopup,
    OrderPopup,
    FooterLayout,
    HeaderLayout,
    'need-bank-cert': DialogDrawer,
    'expired': DialogDrawer,
    'empty-client-bank-account': DialogDrawer,
    TitleAndMessage,
    InvoiceCard,
    ClientAccountCreatePopup: ClientAccountFormPopup,
    ClientAccountUpdatePopup: ClientAccountFormPopup,
    ClientAccountSelectionPopup,
    ClientBankCodeSelectionPopup,
    TransferPopups,
    [Row.name]: Row,
    [Checkbox.name]: Checkbox,
  },
  filters: {
    toCurrency,
  },
})
export default
class NeedTransferTabPanel extends Mixins(Translation, PopupHandlerMixin) {
  @Prop({default: false, type: Boolean}) isCancelSelect: boolean
  @Prop({default: 0, type: Number}) windowScrollY: number
  @Prop({default: false, type: Boolean}) isActive: boolean
  @Prop({default: false, type: Boolean}) isRequiredReload: boolean
  @Prop({default: '', type: String}) tabName: string

  @invoices.State('invoices') invoices: Invoice[]
  @invoices.State('nextOffset') nextOffset: null | number
  @invoices.State('count') count: null | number
  @invoices.Action('getInvoices') getInvoices
  @invoices.Action('getInvoice') getInvoice: (payload: {id: string}) => Promise<Invoice>
  @invoices.Action('updateInvoiceStatus') updateInvoiceStatus
  @invoices.Mutation('clearInvoices') clearInvoices
  @invoices.Mutation('updateInvoicesItem') updateInvoicesItem
  @layout.Mutation('updateError') updateError
  @clients.Action('getClients') getClients
  @clients.Action('getClientAccount') getClientAccount
  @clients.Action('deleteClientAccount') deleteClientAccount: (payload: DeleteClientBankAccountPayload) => Promise<void>
  @clients.State('clients') clients
  @clients.State('clientAccounts') clientAccounts
  @clients.State('nextOffset') clientsNextOffset
  @clients.Mutation('clear') clear
  @institutions.Action('getCertInstitutions') getCertInstitutions
  @institutions.Getter('hometaxStatus') hometaxStatus
  @institutions.Getter('bankStatus') bankStatus
  @institutions.Getter('gtmInfo') institutionsGtmInfo
  @transfer.Mutation('updateTransfer') updateTransfer
  @banks.Mutation('updateBankCode') updateBankCode
  @biz.State('isCorporate') isCorporate
  @gtm.Action('setBizProperty') setBizProperty: (payload: BizPropertyPayload) => void

  @Ref('listView') readonly listView: any

  loading: boolean = true
  changingStatus: boolean = false
  checkedInvoices: string[] = []
  isSelected: boolean = false
  open: boolean = false
  expired: boolean = false
  dialogName: DialogName = ''
  selectedOrder: string = 'newest'
  openOrder: boolean = false
  openClientFilter: boolean = false
  selectedClient: null | Client = null
  page: number = 1
  loadingClients: boolean = false
  isError: boolean = false
  openChangeStatus: boolean = false
  selectedInvoice: any = {}
  selectedInvoiceStatus: string = ''
  selectedInvoiceId: string = ''
  isFirstActive: boolean = true

  get availableTransferMaxCount(): number {
    return AVAILABLE_TRANSFER_MAX_COUNT
  }

  get isAvailableLoadInvoices(): boolean {
    const {hometaxStatus} = this
    return hometaxStatus === 'success' || hometaxStatus === 'expired'
  }

  get filterItemList(): object[] {
    return [
      {
        id: 'order',
        value: this.ts(`order.${this.selectedOrder}`),
        icon: 'arrow-down-sm',
      },
      {
        id: 'client-filter',
        value: this.selectedClient ? this.selectedClient.name : `${this.ts('client')} ${this.ts('entire')}`,
        icon: this.selectedClient ? 'cancel-sm' : 'search',
      },
    ]
  }

  get isEmpty(): boolean {
    return this.count === 0
  }

  get emptyMessage() {
    const {hometaxStatus, ts, isEmpty, selectedClient} = this
    if(hometaxStatus === 'pending' || hometaxStatus === 'failure') return ts('message.none-cert')
    else if(hometaxStatus === 'processing') return ts('message.processing-cert')
    else if(isEmpty && !selectedClient) return ts('message.empty-invoices')
    else if(selectedClient) return ts('message.empty-search-invoices')
    return ''
  }

  get emptyStatus() {
    const {hometaxStatus, selectedClient} = this
    if(hometaxStatus === 'pending' || hometaxStatus === 'processing' || hometaxStatus === 'failure') return 'empty'
    else if(selectedClient) return 'search'
    return 'kakao'
  }

  get buttonOption() {
    const {checkedTotalAmount, isSelectMode, hometaxStatus, ts, isEmpty} = this
    const title = [ts('footer.transfer-register')]
    const registerCertTitle = ts('footer.register-cert')
    const plzSelectTitle = ts('footer.plz-select')

    if(hometaxStatus === 'pending' || hometaxStatus === 'failure' || hometaxStatus === 'expired') {
      return {
        id: 'payment',
        title: registerCertTitle,
        kind: 'primary',
        disabled: false,
      }
    } else if(isEmpty) {
      return {
        id: 'payment',
        title: ts('footer.transfer-register'),
        kind: 'info',
        disabled: true,
      }
    } else if(!isSelectMode) {
      return {
        id: 'payment',
        title: title.join(' '),
        kind: 'primary',
        disabled: false,
      }
    } else if(checkedTotalAmount) {
      title.unshift(`${toCurrency(checkedTotalAmount)}${ts('KRW')}`)
      return {
        id: 'payment',
        title: title.join(' '),
        kind: 'primary',
        disabled: false,
      }
    }
    return {
      id: 'payment',
      title: plzSelectTitle,
      kind: 'info',
      disabled: true,
    }
  }

  get invoiceList() {
    const {invoices, isEmpty} = this
    if(invoices && !isEmpty) {
      return invoices
    }
    return []
  }

  get orderList() {
    const {ts} = this
    return [
      {title: ts('order.newest'), value: 'newest'},
      {title: ts('order.lowAmount'), value: 'lowAmount'},
      {title: ts('order.highAmount'), value: 'highAmount'},
    ]
  }

  get isSelectMode() {
    return Boolean(this.isSelected)
  }

  get totalCount() {
    return this.count
  }

  get checkedTotalAmount() {
    return sumBy(this.checkedInvoices, 'amount')
  }

  get toCurrency() {
    return toCurrency
  }

  get isVisibleFooter() {
    return this.hometaxStatus !== 'processing'
  }

  get dialogOptions(): DialogOptions {
    const {ts, tc, isCorporate} = this
    const options: DialogOptions = {
      header: '',
      title: '',
      description: '',
      status: '',
      showCancel: true,
      closeFunc: () => null,
      cancelText: '',
      confirmText: '',
      translation: '',
    }
    // eslint-disable-next-line default-case
    switch(this.dialogName) {
      case 'inspect-bank':
        options.title = ts('confirm.inspect-bank.title')
        options.description = ts('confirm.inspect-bank.description')
        options.translation = 'pages.invoices.dialog.btn'
        options.status = 'failed'
        options.cancelText = 'close'
        options.confirmText = 'confirm'
        break
      case 'expired':
        options.title = ts('confirm.confirmed-expired.title')
        options.description = tc('confirm.confirmed-expired.description', isCorporate)
        options.translation = 'pages.invoices.dialog.btn'
        options.status = 'failed'
        options.closeFunc = (status: boolean) => {
          if(!status) {
            this.dialogName = ''
          } else {
            this.togglePopup('certPopups')
            this.dialogName = ''
          }
        }
        options.cancelText = 'cancel'
        options.confirmText = 're-register'
        break
      case 'need-bank-cert':
        options.header = ts('confirm.need-bank-cert.title')
        options.translation = 'pages.invoices.dialog.btn'
        options.status = null
        options.closeFunc = (status: boolean) => {
          if(!status) {
            this.dialogName = ''
          } else {
            this.togglePopup('certPopups')
            this.dialogName = ''
          }
        }
        options.cancelText = 'cancel'
        options.confirmText = 'cert-register'
        break
      case 'empty-client-bank-account':
        options.translation = 'pages.invoices.dialog.btn'
        options.status = null
        options.closeFunc = (status: boolean) => {
          if(!status) {
            this.dialogName = ''
          } else {
            this.openPopup('clientAccountCreateForm')
          }
        }
        options.cancelText = 'cancel'
        options.confirmText = 'register'
        break
    }

    return options
  }
  @Watch('isSelected', {immediate: true})
  __isSelected(val) {
    this.$emit('on-cancel', val)
  }
  @Watch('isCancelSelect', {immediate: true})
  __isCancelSelect(val) {
    if(!val) {
      this.onClose()
    }
  }

  @Watch('selectedOrder')
  __selectedOrder() {
    this.reLoadInvoices()
  }

  @Watch('selectedClient')
  __selectedClient() {
    this.reLoadInvoices()
  }

  @Watch('isActive', {immediate: true})
  __isActive(value) {
    if(value) {
      if(this.isFirstActive) {
        this.initData()
      } else if(this.isRequiredReload) {
        this.reLoadInvoices()
      }
    }
  }

  async initData() {
    this.isError = false
    await this.getCertInstitutions()
    this.clearInvoices()
    if(this.isAvailableLoadInvoices) {
      this.loadInvoices()
      if(this.hometaxStatus === 'expired') {
        this.openDialog('expired')
      }
    } else {
      this.loading = false
    }

    if(this.isFirstActive) {
      this.isFirstActive = false
    }

    this.setBizProperty({
      event: 'setBizProperty',
      bizProperty: this.institutionsGtmInfo
    })
  }

  invoiceIndex(invoiceId) {
    return this.checkedInvoices.findIndex((invoice: any) => invoice.id === invoiceId)
  }

  isChecked(invoiceId) {
    return this.invoiceIndex(invoiceId) > -1
  }

  isAvailableTransfer(status) {
    return status === 'pending' || status === 'failed'
  }

  async onCheckInvoice(invoice) {
    if(!this.isChecked(invoice.id)) {
      const result: Invoice = await this.loadInvoice(invoice)
      this.updateInvoicesItem(result)

      if(this.availableCheck(result)) {
        return this.check(result)
      }

      await this.loadClientBankAccounts(result)
      this.selectedInvoice = result
      if(this.clientAccounts.length) {
        this.openPopup('clientAccountSelection')
      } else {
        this.openDialog('empty-client-bank-account')
      }
    } else {
      this.unCheck(invoice)
    }
  }

  availableCheck(invoice: Invoice): boolean {
    const {id, status, hasClientBankAccount} = invoice
    return hasClientBankAccount && !this.isChecked(id) && this.isAvailableTransfer(status)
  }

  check(invoice) {
    const addData = JSON.parse(JSON.stringify(invoice))
    this.checkedInvoices.push(addData)
  }

  unCheck(invoice) {
    this.checkedInvoices.splice(this.invoiceIndex(invoice.id), 1)
  }

  reLoadInvoices() {
    this.clearInvoices()
    this.loadInvoices()
  }

  loadInvoices() {
    this.loading = true
    const {id: clientId} = this.selectedClient || {}
    return this.getInvoices({order: this.selectedOrder, client: clientId})
      .then(() => {
        this.loading = false
        if(this.isRequiredReload) {
          this.$emit('remove-required-reload-list', this.tabName)
        }
        this.listView.fillContents()
      })
      .catch((error) => {
        this.isError = true
        this.updateError({
          id: 'init-invoices',
          message: this.ts('error.get-invoice'),
        })
        this.loading = false
        throw error
      })
  }

  loadClients(name) {
    this.loadingClients = true
    this.getClients({name})
      .then(() => {this.loadingClients = false})
      .catch((error) => {
        this.loadingClients = false
        this.updateError({
          id: 'get-clients',
          message: this.ts('error.get-clients'),
        })
        throw error
      })
  }

  loadInvoice(invoice) {
    return this.getInvoice({id: invoice?.id})
      .catch((error) => {
        const {ts} = this
        this.updateError({
          id: 'get-invoice',
          message: `${ts('invoice')} ${ts('info')}를 가져오는데 ${ts('failed')}하였습니다.`
        })
        throw error
      })
  }

  onClick(invoice) {
    const {id: invoiceId} = invoice
    if(this.isSelectMode) {
      return
    }
    if(this.bankStatus === 'processing') {
      this.openDialog('need-bank-cert')
    } else if(invoiceId === 'empty' || invoiceId === 'processing') {
      return null
    } else {
      this.$router
        .push({
          name: 'received-invoice-detail',
          params: {invoiceId},
        })
        .catch((err) => err)
    }
  }

  openDialog(dialogName: DialogName) {
    this.dialogName = dialogName
    this.open = true
  }

  onFooter() {
    const {hometaxStatus, bankStatus} = this
    if(hometaxStatus === 'pending' || hometaxStatus === 'failure') {
      this.openPopup('certPopups')
    } else if(hometaxStatus === 'expired') {
      this.openDialog('expired')
    } else if(bankStatus === 'processing') {
      this.openDialog('need-bank-cert')
    } else if(!this.isSelected) {
      this.isSelected = true
    } else if(!this.checkedTotalAmount) {
      return false
    } else {
      this.updateTransfer(this.checkedInvoices)
      this.openPopup('transferPopups')
    }
  }

  onClose() {
    this.checkedInvoices = []
    this.isSelected = false
  }

  async onAccountSelectionPopup(invoice) {
    this.selectedInvoice = invoice
    await this.loadClientBankAccounts(invoice)
    this.togglePopup('clientAccountSelection')
  }

  loadClientBankAccounts(invoice) {
    return this.getClientAccount({id: invoice.clientId})
      .catch((error) => {
        this.updateError({
          id: 'get-client-accounts',
          message: this.ts('error.get-client-accounts'),
        })
        throw error
      })
  }

  onCloseCertPopup() {
    this.closePopup('certPopups')
    this.initData()
  }

  onSelectOrder(value) {
    this.selectedOrder = value
  }

  onSelectClient(value) {
    this.selectedClient = value
  }

  onScroll() {
    if(this.nextOffset === null) return
    this.loadInvoices()
  }

  onClickClientFilter() {
    if(this.isError) return
    if(this.selectedClient) {
      this.selectedClient = null
    } else {
      this.openClientFilter = true
    }
  }

  onCompletedWorkflows() {
    this.reLoadInvoices()
    this.$emit('set-required-reload-list', this.tabName)
  }

  onClickInvoiceMore(invoice: any) {
    if(this.isSelectMode) {
      return
    }
    if(invoice) {
      this.selectedInvoiceId = invoice.id
      this.selectedInvoiceStatus = invoice.status
      this.openChangeStatus = true
    }
  }

  onChangeStatus(status) {
    this.changingStatus = true
    this.updateInvoiceStatus({id: this.selectedInvoiceId, status})
      .then(() => {
        this.reLoadInvoices()
        this.$emit('set-required-reload-list', this.tabName)
      })
      .catch((error) => {
        this.updateError({
          id: 'update-invoice-status',
          message: this.ts('error.update-invoice-status'),
        })
        throw error
      })
      .finally(() => {
        this.changingStatus = false
        this.selectedInvoiceId = ''
        this.selectedInvoiceStatus = ''
      })
  }

  completeUpdateClientBankAccount(updateInvoiceData) {
    this.updateInvoicesItem(updateInvoiceData)
    if(this.availableCheck(updateInvoiceData)) {
      this.check(updateInvoiceData)
    }
  }

  codeSelected(code) {
    this.updateBankCode(code)
    this.openPopup('clientAccountCreateForm')
  }

  deleteClientBankAccount(clientId, bankAccountId) {
    this.deleteClientAccount({clientId, bankAccountId})
      .then(() => {
        this.invoices.forEach((invoice) => {
          if(invoice.clientId === clientId && invoice.clientBankAccount?.id === bankAccountId) {
            const updateInvoiceData = {
              ...invoice,
              clientBankAccount: {},
              hasClientBankAccount: false,
            }
            this.updateInvoicesItem(updateInvoiceData)
            this.unCheck(invoice)
          }
        })
      })
      .catch((error) => {
        const {ts} = this
        this.updateError({
          id: 'delete-client-bank-account',
          message: `${ts('client')} ${ts('account')}를 ${ts('delete')}하는데 ${ts('failed')}하였습니다.`,
        })
        throw error
      })
  }
}
